import { httpClient } from '@/api/http';

export interface LayerSplits {
  [key: string]: number;
}

export interface BonusConfig {
  id: number;
  bonusPool: number;
  qualifyingEvent: string;
  fallbackRule: string;
  layerSplits: LayerSplits;
  totalDistributionPercentage: number;
  isActive: boolean;
  effectiveFrom: string;
  createdAt: string;
}

export interface ShareConfig {
  id: number;
  sharePercentage: number;
  shareModel: string;
  fallbackRule: string;
  qualifyingActivities: string[];
  layerSplits: LayerSplits;
  totalDistributionPercentage: number;
  isActive: boolean;
  effectiveFrom: string;
  createdAt: string;
}

export interface Treasury {
  id: number;
  totalMinted: number;
  reservePool: number;
  updatedAt: string;
}

export interface ReferralConfigResponse {
  bonusConfig: BonusConfig;
  shareConfig: ShareConfig;
  treasury: Treasury;
}

export interface UpdateBonusConfigPayload {
  bonusPool: number;
  qualifyingEvent: string;
  fallbackRule: string;
  layerSplits: LayerSplits;
  totalDistributionPercentage: number;
}

export interface UpdateShareConfigPayload {
  sharePercentage: number;
  shareModel: string;
  fallbackRule: string;
  qualifyingActivities: string[];
  layerSplits: LayerSplits;
  totalDistributionPercentage: number;
}

export interface ReferralHistoryItem {
  id: number;
  type: 'share' | 'bonus';
  version: number;
  title: string;
  createdAt: string;
}

export async function getReferralConfig(): Promise<ReferralConfigResponse> {
  const { data } = await httpClient.get<ReferralConfigResponse>('/admin/referral/config');
  return data;
}

export async function updateBonusConfig(payload: UpdateBonusConfigPayload): Promise<BonusConfig> {
  const { data } = await httpClient.patch<BonusConfig>('/admin/referral/config/bonus', payload);
  return data;
}

export async function updateShareConfig(payload: UpdateShareConfigPayload): Promise<ShareConfig> {
  const { data } = await httpClient.patch<ShareConfig>('/admin/referral/config/dynamic-share', payload);
  return data;
}

export interface GetReferralHistoryParams {
  skip?: number;
  take?: number;
}

export async function getReferralConfigHistory(
  params?: GetReferralHistoryParams
): Promise<ReferralHistoryItem[]> {
  const { data } = await httpClient.get<ReferralHistoryItem[]>('/admin/referral/config/history', {
    params,
  });
  return data;
}
